import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";

import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { STUDENT_ASSIGNMENT_API } from "../../../api/api";

import { RiArrowDownSLine } from "react-icons/ri";

// import StudentcertificateCard from "../../../assets/student/no-certificates.png";
import NotFoundAssignment from "../../../assets/icons/student/assignment.svg";

import Card1 from "../../../assets/student/student-assignments.png";
// import Card2 from "../../../assets/student/home-backend.png";
// import Card3 from "../../../assets/student/home-mern.png";
// import Card4 from "../../../assets/student/home-digital.png";
// import Card5 from "../../../assets/student/home-uiux.png";
// import Card6 from "../../../assets/student/home-data.png";

import { handleApiError } from "../../../utils/apiErrorHandler";

import "./StudentAssignment.css";

const StudentAssignment = () => {
  const navigate = useNavigate();

  const [assignments, setAssignments] = useState([]);
  const [activeTab, setActiveTab] = useState("ALL");

  const [selectedCategory, setSelectedCategory] = useState("All Assignments");

  // Counts from API
  const [counts, setCounts] = useState({
    totalAssignments: 0,
    pendingAssignments: 0,
    submittedAssignments: 0,
  });

  //loading
  const [loadingAllAssignment, setAllAssignmentLoading] = useState(true);

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  useEffect(() => {
    // Map course title to local images
    const courseImages = {
      "Advanced Javascript": Card1,
      "React.js": Card1,
      "UI/UX Designer": Card1,
      JavaScript: Card1,
      "Node.js": Card1,
      Testing: Card1,
    };

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");

    if (!userId || !token) {
      setAllAssignmentLoading(false);
      navigate("/signin");

      return;
    }

    const fetchAssignments = async () => {
      try {
        const response = await axios.post(
          STUDENT_ASSIGNMENT_API.GET_EXAM_STUDENT,
          { student_id: userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const data = response.data;

        if (data.statusCode === 200) {
          const regularAssignments = (data.data.assignment || []).map(
            (item) => ({
              assignmentId: item.assignment_id,
              assignmentTitle: item.assignment_title,
              assignmentStatus: item.status,
              totalQuestions: item.total_questions,
              correctAnswers: item.correct_answers,
              wrongAnswers: item.wrong_answers,
              courseTitle: (item.course_title || "").trim(),
              courseImage:
                courseImages[(item.course_title || "").trim()] || Card1,
              isUnlocked: item.is_unlocked,
              type: "REGULAR",
            }),
          );

          // 🔹 Final Assignments
          const finalAssignments = (data.data.finalassignment || []).map(
            (item) => ({
              assignmentId: item.final_assignment_id,
              assignmentTitle: item.assignment_title,
              assignmentStatus: item.status,
              totalQuestions: Number(item.total_questions) || 0,
              correctAnswers: item.correct_answers || 0,
              wrongAnswers: item.wrong_answers || 0,
              courseTitle: (item.course_title || "").trim(),
              courseImage:
                courseImages[(item.course_title || "").trim()] || Card1,
              isUnlocked: item.is_unlocked,
              // unlockDate: item.unlocked_date
              //   ? new Date(item.unlocked_date)
              //   : null,
              type: "FINAL",
            }),
          );

          const allAssignments = [...regularAssignments, ...finalAssignments];

          setAssignments(allAssignments);

          // Set counts from API
          const counts = data?.data?.counts || {};
          setCounts({
            totalAssignments: counts.total_assignments,
            pendingAssignments: counts.pending_assignments,
            submittedAssignments: counts.submitted_assignments,
          });
        } else {
          // This will handle any 2xx response that is not 201
          showErrorToast(data.message);
        }
      } catch (error) {
        console.error("Error fetching assignments:", error);
        // Server responded with non-2xx status (like 400, 500)

        // CHECK (expiry / invalid token)
        handleApiError(error, navigate, showErrorToast, "/signin");
      } finally {
        setAllAssignmentLoading(false);
      }
    };

    fetchAssignments();
  }, [navigate]);

  // Categories for filter dropdown
  const categories = useMemo(
    () => [
      "All Assignments",
      ...new Set(assignments.map((item) => item.courseTitle)),
    ],
    [assignments],
  );

  // Filter logic
  const filteredAssignments = useMemo(() => {
    return assignments
      .filter((assignment) => {
        if (activeTab === "ALL") return assignment.type === "REGULAR";

        if (activeTab === "PENDING")
          return (
            assignment.type === "REGULAR" &&
            assignment.assignmentStatus?.toLowerCase() === "pending"
          );

        if (activeTab === "COMPLETED")
          return (
            assignment.type === "REGULAR" &&
            assignment.assignmentStatus?.toLowerCase() === "completed"
          );

        if (activeTab === "FINAL") return assignment.type === "FINAL";

        return false;
      })

      .filter((assignment) =>
        selectedCategory === "All Assignments"
          ? true
          : assignment.courseTitle === selectedCategory,
      );
  }, [assignments, activeTab, selectedCategory]);

  if (loadingAllAssignment) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Container fluid className="student-certificate-section-container">
      <Row className="align-items-center mb-3">
        <h2 className="student-certificate-section-title">My Assignment</h2>
        <p className="student-certificate-section-description">
          Practice your knowledge by completing course assignments.
        </p>
      </Row>

      <div className="student-certificate-banners">
        <Row className="student-certificate-banners-row">
          <Col className="student-certificate-banners-item">
            <p className="student-certificate-banners-label">All Assignments</p>
            <h2 className="student-certificate-banners-value">
              {counts.totalAssignments || "-"}
            </h2>
          </Col>

          <Col className="student-certificate-banners-item">
            <p className="student-certificate-banners-label">
              Pending Assignments
            </p>
            <h2 className="student-certificate-banners-value">
              {counts.pendingAssignments || "-"}
            </h2>
          </Col>

          <Col className="student-certificate-banners-item">
            <p className="student-certificate-banners-label">
              Submitted Assignments
            </p>
            <h2 className="student-certificate-banners-value">
              {counts.submittedAssignments || "-"}
            </h2>
          </Col>
        </Row>
      </div>

      <div className="student-certificate-tabs student-assignment-section-tabs">
        <Row className="align-items-center">
          {/* TABS */}
          <Col md={9}>
            <div className="student-certificate-tabs-buttons">
              <button
                className={activeTab === "ALL" ? "active" : ""}
                onClick={() => setActiveTab("ALL")}
              >
                All Assignments
              </button>

              <button
                className={activeTab === "PENDING" ? "active" : ""}
                onClick={() => setActiveTab("PENDING")}
              >
                Pending Assignments
              </button>

              <button
                className={activeTab === "COMPLETED" ? "active" : ""}
                onClick={() => setActiveTab("COMPLETED")}
              >
                Submitted Assignments
              </button>

              <button
                className={activeTab === "FINAL" ? "active" : ""}
                onClick={() => setActiveTab("FINAL")}
              >
                Final Assignment{" "}
                {/* <span className="student-sidebar-badge">1</span> */}
              </button>
            </div>
          </Col>

          <Col md={3} className="d-flex justify-content-end">
            <div className="student-assignment-filter">
              <select
                className="student-assignment-filter-select"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                {categories.map((cat, index) => (
                  <option key={index} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
              <RiArrowDownSLine className="student-assignment-filter-select-arrow" />
            </div>
          </Col>
        </Row>
      </div>

      {/* Assignments list */}
      {filteredAssignments.length > 0 ? (
        filteredAssignments.map((assignment) => {
          const isClickable =
            assignment.assignmentStatus?.toLowerCase() === "completed" &&
            assignment.isUnlocked;

          return (
            <div
              className="student-assignment-section"
              key={`${assignment.type}-${assignment.assignmentId}`}
            >
              <div className="student-assignment-title-wrap">
                <img
                  src={assignment.courseImage}
                  alt="Assignment"
                  className="student-assignment-title-icon"
                />
                <div className="student-assignment-left my-2">
                  <h6>{assignment.assignmentTitle}</h6>

                  <span
                    className="student-assignment-left-span-t"
                    title={assignment.courseTitle}
                  >
                    Course: {assignment.courseTitle}
                  </span>
                  <span
                    className={
                      assignment.assignmentStatus?.toLowerCase() === "pending"
                        ? "student-assignment-badge pending"
                        : "student-assignment-badge completed"
                    }
                  >
                    {assignment.assignmentStatus}
                  </span>

                  {/* Unlock info for locked assignments */}
                  {/* {assignment.type === "FINAL" && !assignment.isUnlocked && (
                  <p className="student-assignment-unlock-info">
                    {assignment.unlockDate
                      ? `Unlock on ${assignment.unlockDate.toLocaleDateString()}`
                      : "Complete previous assignment to unlock!"}
                  </p>
                )} */}
                </div>
              </div>

              <div
                className="student-assignment-center-totals"
                onClick={() => {
                  if (
                    assignment.assignmentStatus?.toLowerCase() !==
                      "completed" ||
                    !assignment.isUnlocked
                  )
                    return;

                  if (assignment.type === "FINAL") {
                    navigate(
                      `/student/final-assignment-result/${assignment.assignmentId}`,
                    );
                  } else {
                    navigate(
                      `/student/assignment-result/${assignment.assignmentId}`,
                    );
                  }
                }}
                style={{
                  cursor:
                    assignment.assignmentStatus?.toLowerCase() ===
                      "completed" && assignment.isUnlocked
                      ? "pointer"
                      : "default",
                }}
              >
                {/* <div className="student-assignment-center-totals"> */}
                <div className="student-assignment-center">
                  <p className="label">Correct</p>
                  <span
                    className={`values ${isClickable ? "student-assignment-completed-hover-number" : ""}`}
                  >
                    {assignment.correctAnswers}
                  </span>
                </div>

                <div className="student-assignment-center">
                  <p className="label">Wrong</p>
                  <span
                    className={`valuess ${isClickable ? "student-assignment-completed-hover-number" : ""}`}
                  >
                    {assignment.wrongAnswers}
                  </span>
                </div>

                <div className="student-assignment-center">
                  <p className="label">Total Questions</p>
                  <span
                    className={`values ${isClickable ? "student-assignment-completed-hover-number" : ""}`}
                  >
                    {assignment.totalQuestions}
                  </span>
                </div>
              </div>
              {/* </div> */}

              <div
                className={`student-assignment-right ${
                  !assignment.isUnlocked ? "locked" : ""
                }`}
                title={
                  !assignment.isUnlocked
                    ? assignment.type === "FINAL"
                      ? `Complete previous assignment to unlock!`
                      : "Complete previous videos to unlock this assignment!"
                    : ""
                }
              >
                {assignment.assignmentStatus?.toLowerCase() === "pending" ? (
                  <Button
                    className={`student-assignment-start-btn ${
                      !assignment.isUnlocked ? "locked" : ""
                    }`}
                    disabled={
                      assignment.assignmentStatus?.toLowerCase() !==
                        "pending" || !assignment.isUnlocked
                    }
                    onClick={() => {
                      if (!assignment.isUnlocked) return;
                      if (assignment.type === "FINAL") {
                        navigate(
                          `/student/final-assignment/${assignment.assignmentId}`,
                        );
                      } else {
                        navigate(
                          `/student/assignment-detail/${assignment.assignmentId}`,
                        );
                      }
                    }}
                  >
                    Start Assignment
                  </Button>
                ) : (
                  <Button className="student-assignment-completed-btn" disabled>
                    Completed
                  </Button>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <div className="student-certificate-empty-box mt-2">
          <img
            src={NotFoundAssignment}
            alt="No Certificates"
            className="student-certificate-empty-icon"
          />
          <h5 className="student-certificate-empty-title">
            No Assignments Available
          </h5>
          <p className="student-certificate-empty-desc">
            You don't have any assignment yet.
          </p>
          {/* <Button
            className="student-certificate-empty-btn"
            onClick={() => navigate("/student/courses")}
          >
            View Available Courses
          </Button> */}
        </div>
      )}
    </Container>
  );
};

export default StudentAssignment;
